require('../js/formValidation/dist/js/formValidation.min.js');
require('../js/formValidation/dist/js/framework/bootstrap.min.js');
require('../js/formValidation/dist/js/language/fr_FR.js');


// WEBPACK FOOTER //
// /home/thivolle/prod/shared/web/bundles/ddfactorycore/assets/main.js